export const cameraMovements = new Map()

// ? MAN z 4.5

cameraMovements.set("initial", {
  positionX: 3.75,
  positionY: 3.1,
  positionZ: 0.57,
  lookAtX: 0,
  lookAtY: 2.2,
  lookAtZ: 4.5,
})

cameraMovements.set("entering-t1", {
  positionX: 3,
  positionY: 3,
  positionZ: 0.67,
  lookAtX: 0,
  lookAtY: 2.2,
  lookAtZ: 4,
})

cameraMovements.set("entering-t2", {
  positionX: 1,
  positionY: 3.2,
  positionZ: 3.3,
  lookAtX: 0,
  lookAtY: 3.1,
  lookAtZ: 3.8,
})

cameraMovements.set("entering-t3", {
  positionX: 1,
  positionY: 3.2,
  positionZ: 5,
  lookAtX: 0,
  lookAtY: 3.1,
  lookAtZ: 0,
})

cameraMovements.set("scroll-end", {
  positionX: 1,
  positionY: 3.2,
  positionZ: -5,
  lookAtX: 0,
  lookAtY: 1.5,
  lookAtZ: -1000,
})
